/**
 * Chart colors for summary reports.
 */
export const BLUE = '#2196F3';
export const GREEN = '#30AD63';
export const ORANGE = '#FF8F00';
export const CYAN = '#00BCD4';
export const YELLOW = '#FDC02F';
export const LIGHT_GREEN = '#A5D867';
export const GREY = '#E6E6E6';
export const WHITE = '#FFFFFF';
export const RED = '#FF3300';

export const BAR_CHART_COLORS: string[] = [ BLUE, GREEN, ORANGE, CYAN, YELLOW, LIGHT_GREEN, GREY];
/** Colors for stacked bar charts with 1 data point */
export const STACKED_BAR_CHART_COLORS_1: string[] = [  ORANGE, BLUE, GREEN, CYAN, YELLOW, LIGHT_GREEN, GREY];
/** Colors for stacked bar charts with 2 data points */
export const STACKED_BAR_CHART_COLORS_2: string[] = [ BLUE, ORANGE, GREEN, CYAN, YELLOW, LIGHT_GREEN, GREY];
/** Colors for stacked bar charts with 3 data points */
export const STACKED_BAR_CHART_COLORS_3_PLUS: string[] = [ BLUE, GREEN, ORANGE, CYAN, YELLOW, LIGHT_GREEN, GREY];
export const COLUMN_CHART_COLORS = BAR_CHART_COLORS;
/** Colors for donut charts with two data points (and none) */
export const AVERAGE_CHART_COLORS: string[] = [ BLUE, ORANGE ];
export const MEDPASS_CHART_COLORS: string[] = [ BLUE, CYAN,GREEN,YELLOW,ORANGE,LIGHT_GREEN];

/** Colors for donut charts with one data points (and none) */
export const DONUT1_CHART_COLORS: string[] = [ ORANGE, GREY ];

/** Colors for donut charts with two data points (and none) */
export const DONUT2_CHART_COLORS: string[] = [ BLUE, ORANGE, GREY ];

/** Colors for donut charts with two data points (and none) */
export const DONUT3_CHART_COLORS: string[] = [ BLUE, GREEN, ORANGE, GREY];


/** Colors for donut charts with four or more data points */
export const DONUT_CHART_COLORS: string[] = [ BLUE, CYAN, GREEN, YELLOW, ORANGE, LIGHT_GREEN, GREY ];
export const TREEMAP_CHART_COLORS = DONUT_CHART_COLORS;

/** Colors for Area Chart with two colors */
export const AREA_CHART_COLORS = DONUT_CHART_COLORS;

/** Colors for orange and blue - for 2 options only */
export const ORANGE_BLUE_THEME_COLORS = DONUT2_CHART_COLORS;

/** Colors for traffic light sequence (semi-circle donut) */
export const TRAFFIC_LIGHT_COLORS: string[] = [ GREEN, YELLOW, RED ];

/** Colors for 4-part traffic light sequence (semi-circle donut) */
export const TRAFFIC_LIGHT_PLUS_COLORS: string[] = [ GREEN, YELLOW, ORANGE, RED ];


